export type ApiService = 'main' | 'hrm' | 'accounts' | 'whatsapp';

export function useApi() {
  const fetchData = async <T = any>(
    endpoint: string,
    options: {
      method?: "GET" | "POST" | "PUT" | "DELETE" | "get" | "post" | "put" | "delete";
      body?: any;
      params?: Record<string, any>;
      headers?: Record<string, string>;
      service?: ApiService;
    } = {}
  ): Promise<{ data: T | null; error: any }> => {
    const config = useRuntimeConfig();
    const token = useCookie('auth_token').value;
    
    // Select base URL based on service
    let apiBase = config.public.apiBase || "/api";
    const service = options.service || 'main';

    if (service === 'hrm') apiBase = config.public.hrmApiBase || "/api/hrm";
    else if (service === 'accounts') apiBase = config.public.accountsApiBase || "/api/accounts";
    else if (service === 'whatsapp') apiBase = config.public.whatsappApiBase || "/api";

    // If client-side browser and apiBase points to localhost while site is on a live domain, redirect to current origin:
    if (typeof window !== 'undefined') {
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      if (!isLocalhost && (apiBase.includes('localhost') || apiBase.includes('127.0.0.1'))) {
        if (service === 'hrm') apiBase = '/api/hrm';
        else if (service === 'accounts') apiBase = '/api/accounts';
        else apiBase = '/api';
      }
    }

    apiBase = apiBase.replace(/\/$/, "");
    let path = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
    
    let url = `${apiBase}${path}`;
    
    // Cleanup if both have /api
    if (apiBase.endsWith("/api") && path.startsWith("/api/")) {
      url = `${apiBase.replace(/\/api$/, "")}${path}`;
    }

    try {
      const response = await $fetch.raw<T>(url, {
        method: (options.method || 'GET') as any,
        body: options.body,
        params: options.params,
        credentials: "include",
        headers: {
          ...options.headers,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          Accept: 'application/json'
        },
      });

      return { data: response._data, error: null };
    } catch (error: any) {
      console.error(`API Error [${service}]:`, error);
      return { data: null, error };
    }
  };

  return {
    fetchData,
  };
}
